import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { RouteSummaryBase } from './RouteSummary'

import { dateSelector } from 'reduxModules/selectors/DateSelectors';
import { bookingActions } from 'reduxModules/actions/BookingActions';
import { isFromUaRouteSelector, routeIdSelector } from 'reduxModules/selectors/RouteSelectors';
import { routeBookingsSummarySelector } from 'reduxModules/selectors/BookingSelectors';

const mapStateToProps = createStructuredSelector({
  date: dateSelector,
  routeId: routeIdSelector,
  isFromUaRoute: isFromUaRouteSelector,
  routeBookingsSummary: routeBookingsSummarySelector
})

const mapDispatchToProps = {
  subscribeDepartureBookings: bookingActions.subscribeDepartureBookings,
  unsubscribeDepartureBookings: bookingActions.unsubscribeDepartureBookings
}

export const RouteSummary = connect(mapStateToProps, mapDispatchToProps)(RouteSummaryBase)



// WEBPACK FOOTER //
// ./src/components/RouteSummary/index.js